//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      messages: 'cart/messages',
      timeout: 'cart/messageTimeout',
      globalHideHiringBanner: 'page/hideHiringBanner',
      promoActive: 'promo/promoActive'
    }),
    showHiringBanner () {
      if (this.$route.fullPath.includes('/careers')) return false
      if (this.$route.fullPath.includes('/checkout')) return false
      if (this.globalHideHiringBanner) return false
      return true
    }
  },
  mounted () {
    this.startPolling()
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    startPolling () {
      this.pollingInterval = setInterval(this.poll, 500)
    },
    stopPolling () {
      clearInterval(this.pollingInterval)
    },
    poll () {
      // Check if any messages are older than the limit
      if (this.messages.filter(message => message.timestamp < (new Date()).valueOf() - this.timeout).length) {
        this.$store.commit('cart/CLEAN_MESSAGES')
      }
    }
  }
}
